import { FAIXAS_DOMINIO } from "./customers/quick-tabs-customers";
import { partnerProgram } from "./customers/tooltips/ScoreTooltip";

export const cardsAccountings = [
    {
        currentPage: 0,
        type: "score",
        buttonPages: true,
        pages: [
            {
                title: "Missão Nucont",
                classScore: "score-pink",
                type: "impact",
                info:
                    "Níveis das contabilidades ativas no Programa de Parceria",
                button: {
                    value: '<i class="fas fa-chart-bar"></i>',
                    onClick: () => {}
                },
                gridColumns: [
                    {
                        tooltip: "Bronze 0",
                        class: "bronze-medal",
                        icon: "fas fa-award",
                        value: "120"
                    },
                    {
                        tooltip: "Bronze 1",
                        class: "bronze-medal",
                        icon: "fas fa-award",
                        value: "120"
                    },
                    {
                        tooltip: "Bronze 2",
                        class: "bronze-medal",
                        icon: "fas fa-award",
                        value: "120"
                    },
                    {
                        tooltip: "Prata",
                        class: "default-medal",
                        icon: "fas fa-award",
                        value: "24"
                    },
                    {
                        tooltip: "Ouro",
                        class: "gold-medal",
                        icon: "fas fa-award",
                        value: "24"
                    },
                    {
                        tooltip: "Embaixador",
                        class: "petroleum-medal",
                        icon: "fas fa-award",
                        value: "24"
                    }
                ],

                totals: [
                    {
                        value: 250,
                        label: "baixos"
                    },
                    {
                        value: 100,
                        label: "médios"
                    },
                    {
                        value: 50,
                        label: "alto"
                    }
                ]
            },
            {
                title: "Nucont Score:",
                score: "Baixo",
                classScore: "score-pink",
                type: "score",
                info: "Score geral das contabilidades ativas",
                button: {
                    value: '<i class="fas fa-chart-bar"></i>',
                    onClick: () => {}
                },

                totals: [
                    {
                        value: 250,
                        label: "baixos"
                    },
                    {
                        value: 100,
                        label: "médios"
                    },
                    {
                        value: 50,
                        label: "alto"
                    }
                ]
            }
        ]
    },
    {
        currentPage: 0,
        type: "status",
        pages: [
            {
                title: "Superlógica",

                info: "Contabilidades com integração",
                button: {
                    value: '<i class="fas fa-chevron-right"></i>',
                    transparent: true
                },
                totals: [
                    {
                        value: 477,
                        label: "ativas"
                    },
                    {
                        value: 147,
                        label: "susp"
                    },
                    {
                        value: 20,
                        label: "inativas"
                    }
                ]
            },
            {
                title: "Trial",
                info: "Contabilidades em modo teste",
                button: {
                    value: '<i class="fas fa-chevron-right"></i>',
                    transparent: true
                },
                totals: [
                    {
                        value: 20,
                        label: "vigentes"
                    },
                    {
                        value: 20,
                        label: "expirados"
                    }
                ]
            }
        ]
    },
    {
        title: "Faturamento total",
        type: "billing.total",
        info: "Soma de todo o faturamento Nucont",
        button: {
            value: '<i class="fas fa-chart-bar"></i>',
            onClick: () => {}
        },
        totals: [
            {
                value: (150000.0).toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL"
                })
            }
        ],
        percent: {
            status: "UP",
            value: 10
        }
    },
    {
        title: "Ticket médio",
        info: "Soma de todo o faturamento Nucont",
        type: "averageTicket",
        totals: [
            {
                value: (1000.0).toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL"
                })
            }
        ],
        percent: {
            status: "UP",
            value: 10
        }
    },
    {
        currentPage: 0,
        titleMain: "Programa de Parceria:",
        type: "program.partner",
        pages: [
            {
                title: "Geral",
                info: partnerProgram,
                button: {
                    value: '<i class="fas fa-chevron-right"></i>',
                    transparent: true
                },
                totals: [
                    {
                        value: 477,
                        label: "engajados"
                    },
                    {
                        value: 147,
                        label: "desengajados"
                    }
                ]
            },
            {
                title: "Embaixador",
                info: partnerProgram,
                button: {
                    value: '<i class="fas fa-chevron-right"></i>',
                    transparent: true
                },
                totals: [
                    {
                        value: 54,
                        label: "engajados"
                    },
                    {
                        value: 24,
                        label: "desengajados"
                    }
                ]
            },
            {
                title: "Ouro",
                info: partnerProgram,
                button: {
                    value: '<i class="fas fa-chevron-right"></i>',
                    transparent: true
                },
                totals: [
                    {
                        value: 170,
                        label: "engajados"
                    },
                    {
                        value: 30,
                        label: "desengajados"
                    }
                ]
            },
            {
                title: "Prata",
                info: partnerProgram,
                button: {
                    value: '<i class="fas fa-chevron-right"></i>',
                    transparent: true
                },
                totals: [
                    {
                        value: 210,
                        label: "engajados"
                    },
                    {
                        value: 39,
                        label: "desengajados"
                    }
                ]
            },
            {
                title: "Bronze",
                info: partnerProgram,
                button: {
                    value: '<i class="fas fa-chevron-right"></i>',
                    transparent: true
                },
                totals: [
                    {
                        value: 70,
                        label: "engajados"
                    },
                    {
                        value: 9,
                        label: "desengajados"
                    }
                ]
            }
        ]
    }

    // {
    //     currentPage: 0,
    //     type: "billing.score",
    //     pages: [
    //         {
    //             title: "Faturamento Score Baixo",
    //             info: "Soma do MRR das contabilidades com Score Baixo",
    //             button: {
    //                 value: '<i class="fas fa-chevron-right"></i>',
    //                 transparent: true
    //             },
    //             totals: [
    //                 {
    //                     value: (15000.0).toLocaleString("pt-BR", {
    //                         style: "currency",
    //                         currency: "BRL"
    //                     })
    //                 }
    //             ],
    //             percent: {
    //                 status: "DOWN",
    //                 value: 10
    //             }
    //         },
    //         {
    //             title: "Faturamento Score Médio",
    //             info: "Soma do MRR das contabilidades com Score Médio",
    //             button: {
    //                 value: '<i class="fas fa-chevron-right"></i>',
    //                 transparent: true
    //             },
    //             totals: [
    //                 {
    //                     value: (70000.0).toLocaleString("pt-BR", {
    //                         style: "currency",
    //                         currency: "BRL"
    //                     })
    //                 }
    //             ],
    //             percent: {
    //                 status: "UP",
    //                 value: 10
    //             }
    //         },
    //         {
    //             title: "Faturamento Score Alto",
    //             info: "Soma do MRR das contabilidades com Score Alto",
    //             button: {
    //                 value: '<i class="fas fa-chevron-right"></i>',
    //                 transparent: true
    //             },
    //             totals: [
    //                 {
    //                     value: (65000.0).toLocaleString("pt-BR", {
    //                         style: "currency",
    //                         currency: "BRL"
    //                     })
    //                 }
    //             ],
    //             percent: {
    //                 status: "UP",
    //                 value: 20
    //             }
    //         }
    //     ]
    // }
];

export const filterTrial = {
    filter: {
        score: [],
        origin: [],
        status: []
    },
    list: [
        {
            label: {
                title: "Score",
                hide: false,
                value: "score"
            },
            checkboxs: [
                {
                    label: "Alto",
                    value: "ALTO",
                    checked: false
                },
                {
                    label: "Médio",
                    value: "MEDIO",
                    checked: false
                },
                {
                    label: "Baixo",
                    value: "BAIXO",
                    checked: false
                }
            ]
        },
        {
            label: {
                title: "Status",
                hide: false,
                value: "status"
            },
            checkboxs: [
                {
                    label: "Vigente",
                    value: "ATIVO",
                    checked: false
                },
                {
                    label: "Expirado",
                    value: "BLOQUEADO",
                    checked: false
                }
            ]
        },
        {
            label: {
                title: "Origem",
                hide: false,
                value: "origin"
            },
            checkboxs: [
                {
                    label: "CNCC",
                    value: "CNCC",
                    checked: false
                },
                {
                    label: "CNCC 2",
                    value: "CNCC2",
                    checked: false
                },
                {
                    label: "CNCC 3",
                    value: "CNCC3",
                    checked: false
                },
                {
                    label: "Conta Azul",
                    value: "CONTAZUL",
                    checked: false
                },
                {
                    // O banco grava FREEMIUN, com N no fim — 64 contabilidades. Com `FREEMIUM`
                    // o filtro não casava com ninguém.
                    label: "Freemium",
                    value: "FREEMIUN",
                    checked: false
                },
                {
                    label: "NTW",
                    value: "NTW",
                    checked: false
                },
                {
                    label: "Nucont Xperience",
                    value: "NUCONT XPERIENCE",
                    checked: false
                },
                {
                    label: "Programa Valor",
                    value: "PROGRAMA VALOR",
                    checked: false
                },
                {
                    label: "CF-Contabilidade",
                    value: "cf-contabilidade",
                    checked: false
                },
                {
                    label: "Mentorados Robson C.",
                    value: "mentorados-robson-cavalcanti",
                    checked: false
                },
                {
                    // Estas duas vêm do formulário de cadastro e vivem em `origin`, não em
                    // `originTrial`. O back filtra pelos dois campos.
                    label: "Cliente real",
                    value: "CLIENTE_REAL",
                    checked: false
                },
                {
                    label: "Cliente teste interno",
                    value: "CLIENTE_TESTE_INTERNO",
                    checked: false
                },
                {
                    label: "AJUDA_RS",
                    value: "AJUDA_RS",
                    checked: false
                },
                {
                    label: "INDICACAO_21",
                    value: "INDICACAO_21",
                    checked: false
                }
            ]
        }
    ]
};
export const filterSuperLogicaCostumer = {
    filter: {
        status: [],
        // `automaticRenovation` e `score` seguem no recorte, sempre vazios: os grupos saíram do
        // painel (poluíam mais do que filtravam), mas a rota continua aceitando as chaves.
        automaticRenovation: [],
        score: [],
        contract: [],
        planInUse: 0,
        accessDays: 0,
        impact: [],
        impactLevel: [],
        statusInternal: [],
        rescission: [],
        integration: [],
        dominioData: []
    },
    list: [
        // "Dados do Domínio" abre a lista: é o filtro que o time usa para achar quem parou de
        // mandar dado, e ficava no meio dela, abaixo de vinte opções. O checkbox "Integração:
        // Domínio" saiu porque a aba "Clientes ativos com Domínio" faz esse recorte — a chave
        // `integration` continua no filtro, é ela que a aba grava.
        {
            // Há quanto tempo entrou dado do Domínio. Vem do cron de madrugada, que grava a
            // data em `integrationsHealth.dominio.lastDataAt`; a faixa é recortada na consulta.
            //
            // As opções NASCEM do catálogo que a coluna usa para classificar a linha. Escritas
            // à mão aqui, as duas listas divergiam no primeiro ajuste de corte — a coluna
            // passaria a classificar por um limite e o filtro a pedir outro, com os testes
            // verdes, porque eles só olham o catálogo.
            label: {
                title: "Dados do Domínio",
                descricao: "Última carga de dados recebida do Domínio",
                hide: false,
                value: "dominioData"
            },
            checkboxs: FAIXAS_DOMINIO.map((faixa) => ({
                label: faixa.label,
                value: faixa.key,
                tooltip: faixa.tooltip,
                checked: false
            }))
        },
        {
            label: {
                title: "Status",
                hide: false,
                value: "status"
            },
            checkboxs: [
                {
                    label: "Ativo",
                    value: "ATIVO",
                    checked: false
                },
                {
                    label: "Suspenso",
                    value: "CONGELADO",
                    checked: false
                },
                {
                    label: "Inativo",
                    value: "INATIVO",
                    checked: false
                }
            ]
        },
        {
            label: {
                title: "Status Interno",
                hide: false,
                value: "statusInternal"
            },
            checkboxs: [
                {
                    label: "Ativo",
                    value: "ATIVO",
                    checked: false
                },
                // Para quem filtra, os dois bloqueios são o mesmo estado: acesso suspenso. A aba
                // "Bloqueados" já recorta pelos dois juntos. Ver `valoresDaOpcao`.
                {
                    label: "Bloqueado",
                    value: "BLOQUEADO",
                    values: ["BLOQUEADO", "BLOQUEADO FINANCEIRO"],
                    tooltip: "Inclui o Bloqueado Financeiro",
                    checked: false
                },
                {
                    label: "Churn",
                    value: "CHURN",
                    checked: false
                },
                // Um só valor: o banco não tem `TRIAL` (o trial é gravado como TRIAL E FREE), e
                // a rota recusa `TRIAL` no `statusInternal` — o antigo checkbox "Trial" dava erro.
                {
                    label: "Trial e Free",
                    value: "TRIAL E FREE",
                    checked: false
                },
                {
                    label: "Não Venda",
                    value: "NÃO VENDA",
                    checked: false
                }
            ]
        },
        {
            label: {
                title: "Nível Parceria",
                hide: false,
                value: "impact"
            },
            checkboxs: [
                {
                    label: "Embaixador",
                    value: "Embaixador",
                    checked: false
                },
                {
                    label: "Ouro",
                    value: "Ouro",
                    checked: false
                },
                {
                    label: "Prata",
                    value: "Prata",
                    checked: false
                },
                {
                    label: "Bronze 0",
                    value: "Bronze 0",
                    checked: false
                },
                {
                    label: "Bronze 1",
                    value: "Bronze 1",
                    checked: false
                },
                {
                    label: "Bronze 2+",
                    value: "Bronze 2+",
                    checked: false
                }
            ]
        },
        {
            label: {
                title: "Contrato",
                hide: false,
                value: "rescission"
            },
            checkboxs: [
                // Quem nunca pediu rescisão e quem já teve o pedido revertido caem aqui:
                // no banco, `churn.config.status` não existe. Combinado com Status "Ativo",
                // é a carteira que está de pé sem pedido de churn em aberto.
                {
                    label: "Sem pedido de churn",
                    value: "sem-pedido",
                    checked: false
                },
                {
                    label: "Em aviso prévio",
                    value: "aguardando",
                    checked: false
                },
                {
                    label: "Encerrado",
                    value: "encerrado",
                    checked: false
                }
            ]
        },
        {
            label: {
                title: "Programa de Parceria",
                hide: false,
                value: "impactLevel"
            },
            checkboxs: [
                {
                    label: "Engajado",
                    value: "Engajado",
                    checked: false
                },
                {
                    label: "Desengajado",
                    value: "Desengajado",
                    checked: false
                }
            ]
        },
        {
            label: {
                title: "Período sem acesso",
                hide: false,
                value: "accessDays"
            },
            radiobuttons: [
                {
                    label: "30 dias",
                    value: 30,
                    checked: false
                },
                {
                    label: "60 dias",
                    value: 60,
                    checked: false
                },
                {
                    label: "90 dias",
                    value: 90,
                    checked: false
                }
            ]
        },
        {
            label: {
                title: "Licença em uso",
                hide: false,
                value: "planInUse"
            },
            radiobuttons: [
                {
                    label: "0% até 30%",
                    value: 30
                },
                {
                    label: "31% até 50%",
                    value: 50
                },
                {
                    label: "51% até 70%",
                    value: 70
                },
                {
                    label: "71% até 100%",
                    value: 100
                }
            ]
        }
    ]
};

export const DownloadUsersPermissions = [
    "renata.vieira@nucont.com",
    "michael.nucont@gmail.com",
    "vinicius.cpo@nucont.com",
    "fernando.pinheiro@nucont.com",
    "lwinther@gmail.com",
    "matheus.queiroga@nucont.com",
    "joice@nucont.com",
    "thaina.souza@nucont.com",
    "eduardomelo.nucont@gmail.com"
];

/**
 * Catálogo das features liberadas por contabilidade.
 *
 * Espelho de `RELEASABLE_FEATURES` no back
 * (`services/accounting/src/_shared/types/features.types.ts`). As chaves são o que o
 * `POST /accounting/update-feature-access` grava em `preferences.features`, e divergir daqui
 * deixa o botão surdo: a preferência é gravada e o menu do cliente nunca muda.
 *
 * O menu de opções da lista repete sobre este array — a próxima feature entra aqui e ganha o
 * botão sozinha, sem mexer no template.
 *
 * `onde` completa a frase da confirmação ("passa a ver X <onde>"): as análises aparecem no menu,
 * Funcionários aparece como aba nos painéis da empresa. `icon` é o ícone do botão.
 * `avisoLiberado`/`avisoRemovido` são o aviso depois de salvar, com a concordância da feature
 * (montados em `utils/feature-release-texts.js`).
 */
export const FEATURES_LIBERAVEIS = [
    {
        key: "hibrido",
        label: "Modelo Híbrido",
        onde: "no menu de Análises",
        icon: "fa-chart-line",
        avisoLiberado: "Modelo Híbrido liberado para esta contabilidade",
        avisoRemovido: "Modelo Híbrido removido desta contabilidade"
    },
    {
        key: "regimeTributario",
        label: "Regime Tributário",
        onde: "no menu de Análises",
        icon: "fa-chart-line",
        avisoLiberado: "Regime Tributário liberado para esta contabilidade",
        avisoRemovido: "Regime Tributário removido desta contabilidade"
    },
    {
        key: "funcionarios",
        label: "Funcionários",
        onde: "nos painéis das empresas, ao lado de Pessoal",
        icon: "fa-users",
        avisoLiberado: "Funcionários liberados para esta contabilidade",
        avisoRemovido: "Funcionários removidos desta contabilidade"
    }
];

/**
 * Como cada feature liberada entra no gate de menu que já existe.
 *
 * O menu do v1 esconde item por `accountingPlan.requiredFeatures`, e o Agente Consultivo já usa
 * esse caminho: o override por contabilidade é injetado como se fosse feature contratada
 * (`hireFeature`), e o gate enxerga os dois caminhos de acesso sem saber que existem dois.
 * As análises seguem o mesmo trilho — assim nenhum mecanismo novo de esconder item nasce aqui.
 *
 * Funcionários fica de fora de propósito: não é item de menu, é uma aba nos painéis da empresa,
 * e a aba lê `preferences.features.funcionarios` direto (`utils/employees-url.js`).
 */
export const FEATURE_PLAN_VALUE = {
    hibrido: "AnaliseHibrido",
    regimeTributario: "AnaliseRegimeTributario"
};
